// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"CustomerForm_formContainer__IHXEb","formGroup":"CustomerForm_formGroup__17-KS"};